import { FaFacebookF, FaTwitter, FaYoutube, FaLinkedin, FaInstagram } from "react-icons/fa";
import './socialbar.css'

const SocialBar = () => {
  return (
    <div className="icon-bar s-soft">
      <a href="https://www.facebook.com/aecci.org.in?mibextid=ZbWKwL" className="facebook s-item">
        <FaFacebookF />
      </a>
      <a href="https://twitter.com/aecci2015" className="twitter s-item">
        <FaTwitter />
      </a>
      <a href="https://www.youtube.com/channel/UCkTKN8LiakB8SsYpIEiB7sw" className="youtube s-item">
        <FaYoutube />
      </a>
      <a href="https://www.linkedin.com/in/asian-exporters-chamber-of-commerce-and-industry-9420a8101?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="linkedin s-item">
        <FaLinkedin />
      </a>
      <a href="https://www.instagram.com/aecci_india/" className="instagram s-item">
        <FaInstagram />
      </a>
    </div>
  );
};

export default SocialBar;
